import clsx from 'clsx';
import { DetailedHTMLProps, TableHTMLAttributes } from 'react';
import styles from './TableBase.module.scss';

interface TableBaseProps
  extends DetailedHTMLProps<
    TableHTMLAttributes<HTMLTableElement>,
    HTMLTableElement
  > {
  fixed?: boolean;
}

export function TableBase({ fixed, className, ...props }: TableBaseProps) {
  return (
    <table
      {...props}
      className={clsx(className, styles.table, { [styles.fixed]: fixed })}
    />
  );
}
